export default "__VITE_ASSET__DRrXPrEy__"